import format from "./format";

const validation = {
  stringRules: { required: true, whitespace: true, type: "string" },
  stringEmailRules: { required: true, whitespace: true, type: "email" },
  commonRules: { required: true },
  whitespace: { whitespace: true },
  requiredRuleWithCommonMessage: {
    required: true,
    message: "Field is required!",
  },
  validateMessages: {
    /* eslint-disable no-template-curly-in-string */
    required: "${label} is required",
    types: {
      email: "Please enter a valid email",
      url: "Please enter a valid URL",
    },
    whitespace: "${label} cannot be empty",
    password:
      "Password combination must be at least 8 characters, 1 lowercase character, 1 uppercase character, 1 number or special character.",
  },
  salaryRangeRestriction: {
    validator: async (_: any, value: any) => {
      if (value) {
        if ((value.length > 0 && Number(value.replace(format.checkCommas, '')) < 10000) || format.numberFormat.test(value)) {
          return Promise.reject(new Error("It should not be lower than 10000"));
        }
      }
    },
  },
  charRefRules: {
    validator: async (_: any, names: any) => {
      if (!names || names.length < 1) {
        return Promise.reject(
          new Error("Provide at least 1 character reference")
        );
      }
    },
  },
  isEmptyOrSpaces: (str: string) => {
    return str === null || str.match(/^\s*$/) !== null;
  },
  // eslint-disable-next-line no-useless-escape
  passwordValidation: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[\d]|.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?])[A-Za-z\d!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]{8,}$/,
  resumeFileExtensions: ".doc, .docx, .pdf, .rtf",
  validFileExtensions: [".doc", ".docx", ".pdf", ".rtf"],
  invalidReferredBy: ["na","n/a","notapplicable","none"],
};

export default validation;
